// extracted by mini-css-extract-plugin
export default {"spinner":"MiniSpinner_spinner__-qNeF","spin":"MiniSpinner_spin__+3Xme"};